import { forEach, isPlainObject, isJSONString } from '../../views/utils'

export default {
  storeKey: 'localStorage',
  store: {
    state: {
      $localStorage: null,
    },
    actions: {
      SET_STORE({ state }, entries) {
        forEach(entries, (value, key) => {
          const storedValue = isPlainObject(value) ? JSON.stringify(value) : value
          state.$localStorage.set(key, storedValue)
        })
        return Promise.resolve()
      },
      INIT_STORE({ commit }, obj) {
        commit('INIT_STORE', obj)
      },
    },
    mutations: {
      INIT_STORE(state, { $localStorage }) {
        state.$localStorage = $localStorage
      },
    },
    getters: {
      localStore: state => (key) => {
        const storedValue = state.$localStorage.get(key)
        return isJSONString(storedValue) ? JSON.parse(storedValue) : storedValue
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/store.js